<section class="content-wrapper">
  <router-outlet></router-outlet>
</section>
